export default __webpack_public_path__ + "static/media/berrycake.adbc3621.jpg";